function hexToHSL(hex) {
  // Elimina el # si está presente
  hex = hex.replace(/^#/, '')

  // Soporta hex de 3 o 6 dígitos
  if (hex.length === 3) {
    hex = hex.split('').map(h => h + h).join('')
  }

  const r = parseInt(hex.slice(0, 2), 16) / 255
  const g = parseInt(hex.slice(2, 4), 16) / 255
  const b = parseInt(hex.slice(4, 6), 16) / 255

  const max = Math.max(r, g, b), min = Math.min(r, g, b)
  let h, s, l = (max + min) / 2

  if (max === min) {
    h = s = 0
  } else {
    const d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)

    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break
      case g: h = (b - r) / d + 2; break
      case b: h = (r - g) / d + 4; break
    }

    h = h * 60
  }

  h = Math.round(h)
  s = Math.round(s * 100)
  l = Math.round(l * 100)

  return `${h} ${s}% ${l}%` // ← formato compatible con DaisyUI
}

export default class ThemeManager {
  constructor(estilos) {
    this.estilos = estilos
  }

  static hexToHSL(hex) {
    hex = hex.replace(/^#/, '')
    if (hex.length === 3) {
      hex = hex.split('').map((h) => h + h).join('')
    }

    const r = parseInt(hex.slice(0, 2), 16) / 255
    const g = parseInt(hex.slice(2, 4), 16) / 255
    const b = parseInt(hex.slice(4, 6), 16) / 255

    const max = Math.max(r, g, b), min = Math.min(r, g, b)
    let h, s, l = (max + min) / 2

    if (max === min) {
      h = s = 0
    } else {
      const d = max - min
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break
        case g: h = (b - r) / d + 2; break
        case b: h = (r - g) / d + 4; break
      }
      h *= 60
    }

    return `${Math.round(h)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`
  }

  // Variables CSS de DaisyUI que esperamos del backend
  static daisyUIVariables = [
    "--p", "--pf", "--pc",
    "--s", "--sf", "--sc", 
    "--a", "--af", "--ac",
    "--n", "--nf", "--nc",
    "--b1", "--b2", "--b3", "--bc",
    "--in", "--inc",
    "--su", "--suc",
    "--wa", "--wac",
    "--er", "--erc",
    "--rounded-box", "--rounded-btn", "--rounded-badge",
    "--animation-btn", "--animation-input",
    "--btn-text-case", "--btn-focus-scale",
    "--border-btn", "--tab-border", "--tab-radius"
  ]

  // Variables personalizadas adicionales
  static customVariables = [
    "font_sans", "font_serif", "font_mono",
    "font_size", "border_width", "padding", "margin"
  ]

  apply() {
    // Aplicar variables CSS de DaisyUI
    ThemeManager.daisyUIVariables.forEach(cssVar => {
      let valor = this.estilos[cssVar]
      
      if (valor) {
        // Si es un color HEX, convertir a HSL para variables de color
        if (this.isColorVariable(cssVar) && valor.startsWith("#")) {
          valor = ThemeManager.hexToHSL(valor)
        }
        
        document.documentElement.style.setProperty(cssVar, valor)
      }
    })

    // Aplicar variables personalizadas
    ThemeManager.customVariables.forEach(customVar => {
      const valor = this.estilos[customVar]
      if (valor) {
        // Mapear variables personalizadas a CSS custom properties
        const cssVar = this.mapCustomVariableToCss(customVar)
        document.documentElement.style.setProperty(cssVar, valor)
      }
    })

    document.documentElement.setAttribute("data-theme", "custom")
  }

  // Determinar si una variable CSS es de color
  isColorVariable(cssVar) {
    const colorVariables = [
      "--p", "--pf", "--pc",
      "--s", "--sf", "--sc",
      "--a", "--af", "--ac", 
      "--n", "--nf", "--nc",
      "--b1", "--b2", "--b3", "--bc",
      "--in", "--inc",
      "--su", "--suc",
      "--wa", "--wac",
      "--er", "--erc"
    ]
    return colorVariables.includes(cssVar)
  }

  // Mapear variables personalizadas a CSS custom properties
  mapCustomVariableToCss(customVar) {
    const mapping = {
      "font_sans": "--font-sans",
      "font_serif": "--font-serif", 
      "font_mono": "--font-mono",
      "font_size": "--font-size",
      "border_width": "--border-width",
      "padding": "--padding",
      "margin": "--margin"
    }
    return mapping[customVar] || `--${customVar.replace('_', '-')}`
  }

  // Crear ThemeManager desde configuración del backend
  static fromBackend(backendConfig) {
    return new ThemeManager(backendConfig)
  }

  // Obtener configuración actual
  getCurrentConfig() {
    return { ...this.estilos }
  }

  // Actualizar configuración
  updateConfig(newConfig) {
    this.estilos = { ...this.estilos, ...newConfig }
    this.apply()
  }

  // Resetear a valores por defecto
  reset() {
    // Limpiar todas las variables CSS custom
    const allVariables = [...ThemeManager.daisyUIVariables, ...ThemeManager.customVariables.map(v => this.mapCustomVariableToCss(v))]
    
    allVariables.forEach(cssVar => {
      document.documentElement.style.removeProperty(cssVar)
    })

    document.documentElement.removeAttribute("data-theme")
    this.estilos = {}
  }
}


export { hexToHSL, ThemeManager }
// Puedes agregar más funciones relacionadas con colores aquí